import "swiper/swiper-bundle.css";

import { FreeMode, Mousewheel, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll("section.video .swiper")).map((video) => {
	const swiper = new Swiper(video, {
		modules: [Pagination, FreeMode, Mousewheel],
		slidesPerView: 1.25,
		spaceBetween: 16,
		freeMode: true,
		mousewheel: false,
		grabCursor: false,
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
		},
	});
});
